import React, { useEffect, useRef, useState } from 'react'
import './style.css'
import { DotsThree, Plus } from '@phosphor-icons/react'
import { Link, useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { CREATE_PRESENTATION } from '../graphql/mutation'
import { useAuth } from '../utils/context'
import { GET_USER } from '../graphql/query'
import { nanoid } from 'nanoid'

export default function Home() {
  const { user } = useAuth()

  return (
    <div className='Home'>
      <span>
        <h2>Recent Presentations</h2>
        <div className='Home_Con1'>
          <CreatePresent data={user?.presentations} />
          {user?.presentations?.map((item, index) => {
            return (
              <div key={index} className='Home_Con_Item'>
                <Link to={`/presentation/${item?.uuid}`} className='Home_Con1_Item'>
                  {item?.thumbnail ?
                    <Thumbnail title={item?.title} data={item?.thumbnail} />
                    :
                    <div className='Home_Con1_Img'>
                      <p>{item?.title}</p>
                    </div>
                  }
                </Link>
                <div className='Home_Con1_Icon' onClick={(e) => {
                  e.stopPropagation()
                }}>
                  <DotsThree weight='bold' />
                </div>
              </div>
            )
          })}
        </div>
      </span>
    </div>
  )
}

function Thumbnail({ data, title }) {
  const [scale, setScale] = useState(1)
  const item = JSON.parse(data)
  const elements = item?.elements ? JSON.parse(item?.elements) : []

  const outerDivRef = useRef(null);

  const handleResize = () => {
    if (outerDivRef.current) {
      const { offsetWidth, offsetHeight } = outerDivRef.current;
      const scaleFactor = Math.min(offsetWidth / 854, offsetHeight / 480);
      setScale(scaleFactor)
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    handleResize()
  }, [])

  if (elements?.length === 0) {
    return (
      <div className='Home_Con1_Img'>
        <p>{title}</p>
      </div>
    )
  }
  return (
    <div ref={outerDivRef} className='Home_Thumbnail_Con'>
      <div onContextMenu={(e) => e?.preventDefault()} className='Presentation_Left_Slide_Preview1' style={{ transform: `scale(${scale})`, transformOrigin: "top", backgroundColor: item?.bgType === 'Solid Color' ? item?.background : null, backgroundImage: item?.bgType !== 'Solid Color' ? item?.background : "none" }}>
        <SlidePreviewElements elements={elements} />
      </div>
    </div>
  )
}

const ReplaceSvgColor = React.memo(({ value, colors, style }) => {
  let values = value || ''
  colors?.forEach(colorMap => {
    const [originalColor, newColor] = Object.entries(colorMap)[0];
    const regex = new RegExp(originalColor, 'g');
    values = values?.replace(regex, newColor);
  })
  return <div style={{ display: "flex" }} dangerouslySetInnerHTML={{ __html: values?.replace('<svg ', `<svg width="${style?.width}" height="${style?.height}" opacity="${style?.opacity || 1}"`) }} />
})

const SlidePreviewElements = React.memo(({ elements }) => {
  return elements?.map((itm, ind) => {
    return (
      <div key={ind} style={{ position: "absolute", transform: `translate(${itm?.currPosition?.x}px, ${itm?.currPosition?.y}px)` }}>
        {itm?.type === 'Text' ?
          <div key={ind} style={{ ...itm?.style }} suppressContentEditableWarning dangerouslySetInnerHTML={{ __html: itm?.value?.replaceAll('\n', '<br/>') }} />
          : itm?.type === 'Image' ?
            <img key={ind} alt='' draggable={false} src={itm?.value} style={{ objectFit: "fill", ...itm?.style, }} />
            : itm?.type === 'SVG' ?
              <ReplaceSvgColor key={ind} value={itm?.value} colors={itm?.colors} style={itm?.style} />
              : itm?.type === 'MCQ' || itm?.type === 'Word Cloud' || itm?.type === 'Q&A' ?
                <div key={ind} style={{ ...itm?.style, overflow: "hidden", alignItems: "center" }}>
                  <div style={{ fontSize: 20, fontWeight: "500", textAlign: "center" }}>{itm?.title}</div>
                </div>
                : itm?.type === 'Group' ?
                  <SlidePreviewElements key={ind} item={itm} />
                  :
                  null}
      </div>
    )
  })
})

function CreatePresent({ data }) {
  const navigation = useNavigate()

  const [create, { loading }] = useMutation(CREATE_PRESENTATION, {
    refetchQueries: [
      { query: GET_USER }
    ]
  })

  const slide1 = { uuid: nanoid(7), bgType: "Solid Color", background: "#ffffff", elements: JSON.stringify([]) }

  const onCreate = () => {
    create({
      variables: {
        "present": {
          "title": "Untitled Presentation",
          "slides": [slide1]
        }
      }
    }).then((e) => {
      navigation(`/presentation/${e?.data?.createPresentation}`)
    })
  }

  return (
    <div className='Home_Con2_Item' onClick={() => loading ? null : onCreate()}>
      {loading ?
        <div className='Home_Con1_Img'>
          <div className='Loader' />
        </div>
        :
        <div className='Home_Con1_Img'>
          <Plus color='#008cff' size={30} />
          <p style={{ color: "#008cff" }}>{data?.length > 0 ? "Create presentation" : "Create your first presentation"}</p>
        </div>
      }
    </div>
  )
}